import { Component, OnInit, ViewChild, ViewChildren, Input, QueryList, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { SnotifyService } from 'ng-snotify';
import { Router, ActivatedRoute } from '@angular/router';
import { PatentSearchDataForm } from '../_models/patent-search-data-form';
import { PatentSearchService } from '../_services/patent-search.service';
import { MatExpansionPanel, ErrorStateMatcher, MatStepper, MatDialog } from '@angular/material';
import { WhiteSpaceValidators } from '../shared/whitespace.validator';
import { SessionActivityDataForm } from '../_models/session-activity-data-form';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { SuccessDialogService } from '../_services/success-dialog.service';

@Component({
  selector: 'app-patent-search',
  templateUrl: './patent-search.component.html',
  styleUrls: ['./patent-search.component.css']
})
export class PatentSearchComponent implements OnInit {

  arrayControl: FormArray;
  panelOpenState: boolean = false;
  projectId: any;
  @ViewChild('stepper') stepper: MatStepper;
  @Input('matTooltip') message: string
  show;
  basicInventionDetailsId: any;
  @ViewChildren('tooltip') tooltips;
  @ViewChildren(MatExpansionPanel) viewPanels: QueryList<MatExpansionPanel>;
  @ViewChild('firstInput') firstInput: ElementRef
  @ViewChild('secondInput') secondInput: ElementRef
  @ViewChild('thirdInput') thirdInput: ElementRef
  @ViewChild('fourthInput') fourthInput: ElementRef
  @ViewChild('fifthInput') fifthInput: ElementRef
  @ViewChild('sixthInput') sixthInput: ElementRef
  @ViewChild('seventhInput') seventhInput: ElementRef

  // patentSearchDataForm: PatentSearchDataForm = new PatentSearchDataForm();

  sessionActivity;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();

  patentSearchDataFormGroup: FormGroup;
  updateFlag = '';
  patentSearchId: any;
  userDataSession;
  checkTable: any;
  userDetailsId = 0;
  userSession;
  projectTitle: String = '';
  doingStatusSelected: string = 'Patent Search';
  respForDailog;
  _allExpandState = false;

  get isDirty(): boolean {
    return JSON.stringify(this.originalDetails) !== JSON.stringify(this.currentDetails);
  }

  private currentDetails: PatentSearchDataForm = new PatentSearchDataForm();
  private originalDetails: PatentSearchDataForm = new PatentSearchDataForm();

  get patentSearchDataForm(): PatentSearchDataForm {
    return this.currentDetails;
  }
  set patentSearchDataForm(value: PatentSearchDataForm) {
    this.currentDetails = value;
    this.originalDetails = { ...value };
  }


  constructor(
    private authService: AuthService,
    private snotifyService: SnotifyService,
    public spinnerService: SpinnerService,
    private formbuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private patentSearchService: PatentSearchService,
    private sesssionActivityService: SesssionActivityService,
    private successDialogService: SuccessDialogService,
    private dialog: MatDialog
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params['id'];
      this.updateFlag = 'true';
    });

  }

  get patentSearchDocuments(): FormArray {
    return <FormArray>this.patentSearchDataFormGroup.get('patentSearchDocumentsGroup.patentSearchDocuments');
  }

  ngOnInit() {
    this.patentSearchFormValidate();
    this.userSession = localStorage.getItem('currentUser');
    this.patentSearchDataForm.userSessionDataForm = JSON.parse(this.userSession);
    this.userDetailsId = this.patentSearchDataForm.userSessionDataForm.userDetailsId;

    this.patentSearchDataFormGroup.get('patentSearchDocumentsGroup.closerReference').valueChanges.subscribe(value => this.setcloserReferenceStatus(value));

    if (this.updateFlag == 'true' && this.projectId > 0) {
      this.activatedRoute.data.subscribe(
        data => {
          const resolvedData: PatentSearchDataForm = data['resolvedData'];
          this.patentSearchDetailsRetrieved(resolvedData);
        }
      )
    }
  }

  public set allExpandState(value: boolean) {
    this._allExpandState = value;
    this.togglePanels(value);
  }

  expandLess(value) {

    switch (value) {
      case 1:
        this.firstInput.nativeElement.focus();
        break;
      case 2:
        this.secondInput.nativeElement.focus();
        break;
      case 3:
        this.thirdInput.nativeElement.focus();
        break;
      case 4:
        this.fourthInput.nativeElement.focus();
        break;
      case 5:
        this.fifthInput.nativeElement.focus();
        break;
      case 6:
        this.sixthInput.nativeElement.focus();
        break;
      case 7:
        this.seventhInput.nativeElement.focus();
      default:
        break;
    }
  }

  public get allExpandState(): boolean {
    return this._allExpandState;
  }

  public togglePanels(value: boolean) {
    this.viewPanels.forEach(p => value ? p.open() : p.close());
  }

  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = "Briefly write about your invention";
        break;
      case 2:
        this.message = "Describe key or important features of the invention";
        break;
      case 3:
        this.message = "Identify and mention the keywords";
        break;
      case 4:
        this.message = "Write search strategies to search in google";
        break;
      case 5:
        this.message = "Identify classes and list it out";
        break;
      case 6:
        this.message = "Form a strategy";
        break;
      case 7:
        this.message = "Review the retrieved reference in detail and list the closer reference with a short description";
      default:
        break;
    }
  }

  patentSearchFormValidate() {
    this.patentSearchDataFormGroup = this.formbuilder.group({
      inventionBrief: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionFeatures: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      keywords: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      searchStrategy: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      listClasses: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      formStrategy: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      patentSearchDocumentsGroup: this.formbuilder.group({
        closerReference: ['', [Validators.required]],
        patentSearchDocuments: this.formbuilder.array([this.patentSearchDocumentRows()])
      })
    });
  }
  patentSearchDocumentRows(): FormGroup {
    return this.formbuilder.group({
      countryName: [''],
      documentStatus: [''],
      referenceNumber: [''],
      inventorName: [''],
      titleCited: [''],
      inventionDifference: [''],
    });
  }

  addNewRow() {
    this.patentSearchDocuments.push(this.patentSearchDocumentRows());
  }

  deleteRow(index: number): void {
    this.patentSearchDocuments.removeAt(index);
    this.patentSearchDocuments.markAsDirty();
  }

  // ===== Change validation =====
  setcloserReferenceStatus(closerRefStatus: string): void {
    for (let i in this.patentSearchDocuments.controls) {
      const countryNameControl = this.patentSearchDocuments.get(i).get('countryName');
      const documentStatusControl = this.patentSearchDocuments.get(i).get('documentStatus');
      const referenceNumberControl = this.patentSearchDocuments.get(i).get('referenceNumber');
      const inventionDifferenceControl = this.patentSearchDocuments.get(i).get('inventorName');
      const inventorNameControl = this.patentSearchDocuments.get(i).get('titleCited');
      const titleCitedControl = this.patentSearchDocuments.get(i).get('inventionDifference');

      if (closerRefStatus === 'Yes') {
        countryNameControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
        documentStatusControl.setValidators([Validators.required]);
        referenceNumberControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
        inventionDifferenceControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
        inventorNameControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
        titleCitedControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
      }
      else {
        countryNameControl.clearValidators();
        documentStatusControl.clearValidators();
        referenceNumberControl.clearValidators();
        inventionDifferenceControl.clearValidators();
        inventorNameControl.clearValidators();
        titleCitedControl.clearValidators();
      }
      countryNameControl.updateValueAndValidity();
      documentStatusControl.updateValueAndValidity();
      referenceNumberControl.updateValueAndValidity();
      inventionDifferenceControl.updateValueAndValidity();
      inventorNameControl.updateValueAndValidity();
      titleCitedControl.updateValueAndValidity();
    }
  }


  saveFormFields() {
    this.sessionActivityDataForm.activityType = 8
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.lastActivitySession = indexNumber;
    this.patentSearchDataForm.sessionActivityDataForm = this.sessionActivityDataForm;

    const currentUser = localStorage.getItem('currentUser');
    this.patentSearchDataForm.userSessionDataForm = JSON.parse(currentUser);

    let arrayObj = this.patentSearchDataFormGroup.get('patentSearchDocumentsGroup.patentSearchDocuments') as FormArray;
    this.patentSearchDataForm.patentSearchDocuments = JSON.stringify(arrayObj.value);

    this.patentSearchService.savePatentSearch(this.patentSearchDataForm).subscribe(
      resp => {
        this.patentSearchDataForm = resp as PatentSearchDataForm;
        this.projectTitle = this.patentSearchDataForm.projectDataForm.projectName;
      }, error => {
        console.log(error);
      })
  }

  gotoPatentDraft() {
    if (this.patentSearchDataFormGroup.valid) {
      this.sessionActivityDataForm.activityType = 8
      let indexNumber = this.stepper.selectedIndex + 1;
      this.sessionActivityDataForm.lastActivitySession = indexNumber;
      this.patentSearchDataForm.sessionActivityDataForm = this.sessionActivityDataForm;

      const currentUser = localStorage.getItem('currentUser');
      this.patentSearchDataForm.userSessionDataForm = JSON.parse(currentUser);

      let arrayObj = this.patentSearchDataFormGroup.get('patentSearchDocumentsGroup.patentSearchDocuments') as FormArray;
      this.patentSearchDataForm.patentSearchDocuments = JSON.stringify(arrayObj.value);

      this.patentSearchService.savePatentSearch(this.patentSearchDataForm).subscribe(
        resp => {
          this.sesssionActivityService.getProjectLastSessionActiityForRedirection(this.userDetailsId, 8, this.projectId).subscribe(
            resp => {
              this.respForDailog = resp;
              if (this.respForDailog.activityType < 9) {
                this.successDialogService.successDialogDoing(8, this.projectId);
              } else {
                this.router.navigate(['/main/patentDraft', this.projectId]);
              }
            }, error => {
              console.log(error);
            })
        }, error => {
          console.log(error);
        })
    }
  }

  patentSearchDetailsRetrieved(patentSearchDataForm: PatentSearchDataForm) {
    this.patentSearchDataForm = patentSearchDataForm;
    this.projectTitle = this.patentSearchDataForm.projectDataForm.projectName;

    // get form array reference
    //  const formarray = this.basicInventionDetailsDataFormGroup.get('inventionPublishDetails') as FormArray;
    let Obj = JSON.parse(this.patentSearchDataForm.patentSearchDocuments);
    if (this.patentSearchDataForm.closerReference == "Yes" && Obj.length > 0) {
      const inventionPublishArray = this.patentSearchDocuments;
      // empty form array
      while (inventionPublishArray.length) {
        inventionPublishArray.removeAt(0);
      }
      // use patchValue instead of setValue
      inventionPublishArray.patchValue(Obj);
      // add form array values in a loop
      Obj.forEach(demoObj => inventionPublishArray.push(this.formbuilder.group(demoObj)))
    }

    this.sesssionActivityService.getProjectLastSessionActiityByUserId(this.userDetailsId, 8, this.projectId).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                setTimeout(() => {
                  this.stepper.selectedIndex = step.index;
                });
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  generatePatentSeaarchPDF() {
    let id = this.patentSearchDataForm.patentSearchId;
    this.patentSearchService.generatePatentSearchPDF(id).subscribe(
      resp => {
        this.router.navigate(['/main/patentDraft']);
      }, error => {
        console.log(error);
        this.snotifyService.error(error);
      })
  }
}


